module.exports = __webpack_public_path__ + "media/images/products/demo/slideri3-4e96374076130557637122f34f3ed829.jpg";